<template>
    <div class="skillItem">
        <i v-if="icon[0] == '-'" :class="`bi bi${icon}`" aria-hidden="true"></i>
        <img v-else-if="icon[0] == '!'" :src="getLocalImage(icon)" loading="lazy" :alt="name + ' icon'" />
        <img v-else :src="icon" loading="lazy" :alt="name + ' icon'" />

        <div class="skill-desc">
            <div class="skill-header">
                <span>{{ name }}</span>
                <!-- <p v-if="year">{{ new Date().getFullYear() - 2000 - year}} years</p> -->
            </div>
            <span>{{ desc }}</span>
            <!-- <span><em>{{ prof }}</em></span> -->

        </div>
    </div>
</template>

<script>
export default {
    name: 'SkillItem',
    props: {
        name: String,
        year: Number,
        icon: String,
        desc: String,
        prof: String
    },
    methods: {
        getLocalImage(icon) {
            try {
                return require(`../assets/${icon.substring(1)}.png`)
            } catch (e) {
                console.warn(`Image not found: ${icon}`)
                return null
            }
        }
    }
}
</script>